import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import DateTimePicker from "react-datetime";
import "react-datetime/css/react-datetime.css";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");

class SuKienHeaderControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
              TenSK: "",
              SoHoSo: null,
              SoPhuongTien: 1,
            }
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "ThoiGian",
      "TenSK",
      "SoHoSo",
    ]);
    s.canSaved = s.dataChanged;
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    console.log("before", s.before, "after", s.after);
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log("after:", this.state.after);
    var check = sukienLayer.validate("header", this.state.after);
    console.log("check:", check);
    if (!check.error) {
      //console.log(JSON.stringify(this.state.after));
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      server
        .post(
          "sukien/saveHeader",
          sukienLayer.chuanHoaSukien("header", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = { ...this.state.after, MaSK: response.MaSK };
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  componentDidMount() {
    this.loadDanhmuc();
  }
  loadDanhmuc() {
    //load danh muc quoc gia
    if (this.props.value === undefined)
      server
        .query("sukien/GetNextSoHoSo")
        .then((response) => {
          this.saveField('SoHoSo', response.SoHoSo);
        })
        .catch((error) => {
          console.log(error);
        });
  }
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>Sự vụ</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.ThoiGian !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Thời gian nhận(*):
              </InputLabel>
              <DateTimePicker
                id="txtThoigian"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.ThoiGian}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.ThoiGian === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('ThoiGian', date);
                      }
                    }
                  }
                }}
                onChange={(date) => {
                  this.saveField(
                    "ThoiGian",
                    date && date.toDate ? date.toDate() : null
                  );
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="txtTenSK"
                className={classes.textbox}
                label="Tên sự vụ(*):"
                autoFocus={true}
                value={this.state.after.TenSK}
                inputProps={{
                  className: classes.uppercaseText,
                  maxLength: 100,
                }}
                onChange={(event) =>
                  this.saveField("TenSK", event.target.value)
                }
                error={this.state.validateStatus.TenSK !== undefined}
                helperText={
                  this.state.validateStatus.TenSK !== undefined
                    ? this.state.validateStatus.TenSK.trangthai
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={4}>
            <InputLabel
                id="labelThoiGianBaoNan"
              >
                Số hồ sơ(*):
              </InputLabel>
              <TextField
                id="txtSoHoSo"
                className={classes.textbox}
                value={this.state.after.SoHoSo}
                inputProps={{ className: classes.uppercaseText, maxLength: 40 }}
                onChange={(event) =>
                  this.saveField("SoHoSo", event.target.value)
                }
                error={this.state.validateStatus.SoHoSo !== undefined}
                helperText={
                  this.state.validateStatus.SoHoSo !== undefined
                    ? this.state.validateStatus.SoHoSo.trangthai
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={2}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    color: "red",
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
});
export default withStyles(styles, { withTheme: true })(SuKienHeaderControl);
